import { render, staticRenderFns } from "./UserH5.vue?vue&type=template&id=224fc9c9"
import script from "./UserH5.vue?vue&type=script&lang=js"
export * from "./UserH5.vue?vue&type=script&lang=js"
import style0 from "./UserH5.vue?vue&type=style&index=0&id=224fc9c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports